module.exports = __webpack_public_path__ + "konsultacje.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/konsultacje.png
// module id = 1628
// module chunks = 0